import sanitizeHtml from "sanitize-html";

const SAFE_LINK_SCHEMES = ["http", "https", "mailto", "tel"];
const SAFE_EMBED_HOSTNAMES = [
    "embed.figma.com",
    "www.figma.com",
    "figma.com",
    "www.youtube.com",
    "youtube.com",
    "www.youtube-nocookie.com",
    "youtube-nocookie.com",
    "player.vimeo.com",
    "open.spotify.com",
    "w.soundcloud.com",
    "www.google.com",
    "maps.google.com",
    "calendly.com",
    "assets.calendly.com",
];

/**
 * Strips all inline style attributes from an HTML string.
 * Handles both single and double quotes around attribute values.
 *
 * @param html - The HTML string to process
 * @returns The HTML string with all style attributes removed
 */
export function stripInlineStyles(html: string): string {
    if (!html) return html;
    return html.replace(/\s*style\s*=\s*["'][^"']*["']/gi, "");
}

export function sanitizeRichTextHtml(html: string | null | undefined): string {
    if (!html) return "";

    return sanitizeHtml(html, {
        allowedTags: [
            "p",
            "br",
            "strong",
            "b",
            "em",
            "i",
            "u",
            "s",
            "ul",
            "ol",
            "li",
            "a",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "code",
            "pre",
            "span",
        ],
        allowedAttributes: {
            a: ["href", "target", "rel", "title"],
            h1: ["class"],
            h2: ["class"],
            h3: ["class"],
            h4: ["class"],
            h5: ["class"],
            h6: ["class"],
            span: ["class"],
        },
        allowedClasses: {
            h1: ["h5"],
            h2: ["h5"],
            h3: ["h5"],
            h4: ["h5"],
            h5: ["h5"],
            h6: ["h5"],
            span: ["h5"],
        },
        allowedSchemes: SAFE_LINK_SCHEMES,
        allowedSchemesAppliedToAttributes: ["href"],
        allowProtocolRelative: false,
    });
}

export function sanitizeEmbedHtml(html: string | null | undefined): string {
    if (!html) return "";

    return sanitizeHtml(html, {
        allowedTags: ["iframe"],
        allowedAttributes: {
            iframe: [
                "allow",
                "allowfullscreen",
                "aria-label",
                "height",
                "loading",
                "referrerpolicy",
                "sandbox",
                "src",
                "title",
                "width",
            ],
        },
        allowedIframeHostnames: SAFE_EMBED_HOSTNAMES,
        allowedSchemes: ["https"],
        allowedSchemesAppliedToAttributes: ["src"],
        allowProtocolRelative: false,
        exclusiveFilter: (frame) => frame.tag === "iframe" && !frame.attribs.src,
    });
}
